import React from 'react';
import { Link } from 'react-router-dom';
import CourseThumbnailSection from '../course/CourseThumbnailSection';
import {
  BookOpen,
  Clock,
  Users,
  Star,
  CheckCircle,
  ChevronLeft
} from 'lucide-react';
import { Eye } from 'lucide-react';

const StudentCourseCard = ({ course, formatTotalDuration, getDurationTextFromDays }) => {

  return (
    <div className="group bg-white rounded-[2.5rem] border border-gray-100 overflow-hidden hover:shadow-2xl transition-all duration-500 flex flex-col h-full">
      <CourseThumbnailSection course={course} onClick={() => window.location.href = `/courses/${course.id}`} />

      {/* Card Body */}
      <div className="p-6 flex flex-col flex-1">
        {/* Title */}
        <h3 className="font-black text-gray-900 text-xl mb-2 line-clamp-1 group-hover:text-primary-600 transition-colors">
          {course.title}
        </h3>
        
        {/* Description */}
        <p className="text-sm text-gray-500 mb-6 line-clamp-2 leading-relaxed">
          {course.description || 'لا يوجد وصف متوفر لهذا الكورس'}
        </p>

        {/* Info Metadata */}
        <div className="flex items-center justify-between mb-6 pb-6 border-b border-gray-50">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 rounded-full bg-primary-100 flex items-center justify-center text-primary-600 font-bold text-xs border border-primary-200">
              {course.teacher_name?.charAt(0)}
            </div>
            <div>
              <span className="text-xs font-bold text-gray-400">معلم المادة</span>
              <span className="text-sm font-bold text-gray-700 block">{course.teacher_name}</span>
            </div>
          </div>
          <div className="flex items-center gap-0.5 text-amber-500">
            <Star size={14} fill="currentColor" />
            <span className="text-xs font-bold">{typeof course.average_rating === 'number' ? course.average_rating.toFixed(1) : '5.0'}</span>
          </div>
        </div>

        {/* Stats Grid */}
        <div className="grid grid-cols-4 gap-2 mb-6 text-xs font-bold text-gray-400">
          <div className="flex flex-col items-center gap-1 p-2 bg-gray-50/50 rounded-xl">
            <BookOpen size={14} className="text-blue-500" />
            <span>{course.lesson_count || 0} درس</span>
          </div>
          <div className="flex flex-col items-center gap-1 p-2 bg-gray-50/50 rounded-xl">
            <Clock size={14} className="text-orange-500" />
            <span>{formatTotalDuration(course)}</span>
          </div>
          <div className="flex flex-col items-center gap-1 p-2 bg-gray-50/50 rounded-xl">
            <Eye size={14} className="text-primary-500" />
            <span>{course.courseViews ?? course.video_views ?? 0} مشاهدة</span>
          </div>
          <div className="flex flex-col items-center gap-1 p-2 bg-gray-50/50 rounded-xl">
            <Users size={14} className="text-blue-600" />
            <span>{course.student_count || 0} طالب</span>
          </div>
        </div>

        {/* Progress Tracking Area */}
        {course.enrollment_status === 'active' && course.progress && (
          <div className="space-y-2 mb-6">
            <div className="flex items-center justify-between text-xs font-black">
              <span className="text-gray-400">تقدمك</span>
              <span className="text-primary-600">{course.progress.completionRate || 0}%</span>
            </div>
            <div className="w-full bg-gray-100 rounded-full h-2 overflow-hidden border border-gray-200">
              <div
                className="bg-primary-600 h-full rounded-full transition-all duration-1000"
                style={{ width: `${course.progress.completionRate || 0}%` }}
              />
            </div>
            <div className="text-xs text-gray-500 text-center">
              {course.progress.completedLessons || 0}/{course.progress.totalLessons || 0} درس مكتمل
            </div>
          </div>
        )}

{/* Action Button */}
<Link
  to={
    course.enrollment_status === 'active' || course.enrollment_status === 'completed'
      ? `/courses/${course.id}`
      : '#'
  }
  className={`w-full py-4 rounded-2xl font-black text-sm flex items-center justify-center gap-2 transition-all transform active:scale-95 shadow-lg mt-auto ${
    course.enrollment_status === 'active'
      ? 'bg-primary-600 text-white hover:bg-primary-700 shadow-primary-100'
      : course.enrollment_status === 'completed'
      ? 'bg-green-50 text-green-700 hover:bg-green-100 shadow-green-50 border border-green-100'
      : 'bg-gray-100 text-gray-400 cursor-not-allowed shadow-none'
  }`}
  onClick={(e) => {
    if (course.enrollment_status !== 'active' && course.enrollment_status !== 'completed') {
      e.preventDefault();
    }
  }}
>
  {course.enrollment_status === 'active' ? (
    <>استكمال الدروس <ChevronLeft size={18} /></>
  ) : course.enrollment_status === 'completed' ? (
    <>لقد أكملت هذا الكورس <CheckCircle size={18} /></>
  ) : (
    'غير متوفر حالياً'
  )}
</Link>
      </div>
    </div>
  );
};

export default StudentCourseCard;
